// 国内机票
const state = {
  searchParams: {}, // 列表查询参数
  orderFillParams: {}, // 订单填写参数,
  orderConfirmParams: {}, // 订单确认参数,
  costParams: {}, // 成本中心
  passengerList: [], // 乘客
  lowPrices: [], // 低价信息
  recommend: []// 推荐信息
}
const getters = {
  searchParams: state => state.searchParams,
  orderFillParams: state => state.orderFillParams,
  orderConfirmParams: state => state.orderConfirmParams,
  costParams: state => state.costParams,
  passengerList: state => state.passengerList,
  lowPrices: state => state.lowPrices,
  recommend: state => state.recommend
}
const mutations = {
  setRecommend (state, data) {
    state.recommend = data || []
  },
  setDomesticSearchParams (state, data) {
    state.searchParams = data || {}
  },
  setDomesticOrderFillParams (state, data) {
    state.orderFillParams = data || {}
  },
  setDomesticOrderConfirmParams (state, data) {
    state.orderConfirmParams = data || {}
  },
  setCostParams (state, data) {
    state.costParams = data || {}
  },
  setPassengerList (state, data) {
    state.passengerList = data || []
  },
  setDomesticLowPrices (state, data) {
    state.lowPrices = data || []
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/domesticStore.js